import { noValidation } from '@post-office/message-maker-browser/message-helpers';
import type {
	FrontendPlacementMessage,
	FrontendStage,
} from '@post-office/message-maker-browser/types';
import type { CreatePlacementMessageConfig } from '@post-office/message-template-contracts/placement-v2';
import {
	PlacementFrontend,
	type PlacementRenderProps,
} from '@post-office/browser--puma/jira-issue-view-comment-top-banner';

import { type MessageTemplateContext } from '../../../index';

import { JiraMcpCommentNudgeBanner } from './components/jira-mcp-comment-nudge-banner';

export const MessageFrontend: (config: CreatePlacementMessageConfig) => FrontendPlacementMessage<{
	render: FrontendStage<PlacementRenderProps>;
}> = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation<MessageTemplateContext & PlacementRenderProps>(),
		Component: ({ onDismiss }: MessageTemplateContext & PlacementRenderProps) => (
			<JiraMcpCommentNudgeBanner onDismiss={onDismiss} />
		),
	},
});
